import React, { useEffect } from 'react'
import styles from '../../../styles/Register.module.scss'
import techTalentStyles from '../../../styles/TechTalent.module.scss'
import { useDropzone } from 'react-dropzone'
import { useTranslation } from 'react-i18next'
import * as Yup from 'yup'

import {
	Card,
	Row,
	Col
} from 'react-bootstrap'

export default function WorkExperience({ inputs, setInputs, setCVData, schema, setSchema }): JSX.Element {
	const { t } = useTranslation()

	const { getRootProps, getInputProps } = useDropzone({
		useFsAccessApi: false,
		accept: {
			'application/vnd.openxmlformats-officedocument.wordprocessingml.document': ['.docx'],
			'application/pdf': ['.pdf'],
			'application/msword': ['.doc']
		},
		maxFiles: 1,
		onDrop: file => {
			if (file.length > 0) {
				setInputs({ ...inputs, cvName: file[0].name })
				setCVData(file[0])
			}
		}
	})

	useEffect(() => {
		const workExperienceSchema = Yup.object().shape({
			cvName: Yup.string()
				.required('Resume is required')
		})

		setSchema(prevSchema => prevSchema.concat(workExperienceSchema))
	}, [setSchema])

	return (
		<>
			<Row className={styles.row}>
				<Col>
					<h5>
						{t('update_profile.upload_resume')}
						<span className={styles.mandatory}>*</span>
					</h5>
					<div {...getRootProps({ className: 'dropzone' })} className={`${styles.uploadDropContainer} ${techTalentStyles.dropzone}`} >
						<input {...getInputProps()} />
						<p>{t('update_profile.drag_and_drop')}</p>
					</div>
					<Card>
						<Card.Header>{t('update_profile.uploaded')}</Card.Header>
						<Card.Body>
							{inputs.cvName === '' ? 'No file uploaded' : inputs.cvName}
						</Card.Body>
					</Card>
				</Col>
			</Row>
		</>
	)
}
